import { NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-encryption-blocker',
  standalone: true,
  templateUrl: './encryption-blocker.component.html',
  styleUrls: ['./encryption-blocker.component.scss'],
  imports: [NgIf]
})
export class EncryptionBlockerComponent {
  @Input() isEncrypted: boolean = false;
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }
}
